import React from 'react';

const Logo = () => {
    return (
        <div className='logo'>
            <img src="./logo192.png" alt="Logo Starwars" />
            {/* Bizarre, les images depuis la balise img sont accessibles dans public donc le chemin est comme-ci on était dans public */}
        </div>
    );
};

export default Logo;